import Layout from '@modules/layout/components/layout';
import Permissions from '@security/permissions';

const PropertySettingsPage = () =>
  import('@modules/property-settings/components/property-settings-page.vue');

export default [
  {
    path: '',
    component: Layout,
    children: [
      {
        name: 'propertySettings',
        path: '/property-settings',
        component: PropertySettingsPage,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.settingsEdit,
        },
      },
    ],
  },
];
